<template>
  <div id="itemlist" class="location-selector">
    <div class="selector-container">
      <h3 class="selector-title">地址選擇</h3>
      <div class="selector-grid">
        <!-- City Selection -->
        <div class="location-field">
          <label class="field-label">
            <span v-if="need" class="required-mark">*</span>
            縣市
          </label>
          <select
            v-model="twcity"
            @change="oncity()"
            class="field-select"
            aria-label="選擇縣市"
          >
            <option value="" disabled>請選擇縣市</option>
            <option v-for="list in mytw" :value="list.city" :key="list.id">
              {{ list.city }}
            </option>
          </select>
        </div>
        
        <!-- Village Selection -->
        <div class="location-field">
          <label class="field-label">
            <span v-if="need" class="required-mark">*</span>
            鄉鎮
          </label>
          <select
            v-model="twvillage"
            @change="onvillage()"
            class="field-select"
            aria-label="選擇鄉鎮"
            :disabled="!twcity"
          >
            <option value="" disabled>請選擇鄉鎮</option>
            <option
              v-for="list in twvillages"
              :value="list.village"
              :key="list.village"
            >
              {{ list.village }}
            </option>
          </select>
        </div>
        
        <!-- Town Selection -->
        <div class="location-field">
          <label class="field-label">
            <span v-if="need" class="required-mark">*</span>
            村里
          </label>
          <select
            v-model="twtown"
            @change="ontwtown()"
            class="field-select"
            aria-label="選擇村里"
            :disabled="!twvillage"
          >
            <option value="" disabled>請選擇村里</option>
            <option v-for="list in twtowns" :value="list.town" :key="list.town">
              {{ list.town }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as moment from "moment/moment";
import TWdata from "../assets/json/twdata.json";
import TW from "../assets/json/tw.json";
export default {
  name: 'Addresslist',
  props: {
    msg: String,
    item: Array,
    winsize: Object,
    need: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      myJson: TWdata,
      mytw: TW,
      address:'',
      twcity: "",
      twtown: "",
      twvillage: "",
      twvillages: [],
      twtowns: [],      
      window: {
            width: 0,
            height: 0
        }   
    }
  }, 
  computed: {
    ...mapState("account", ["status", "user"]),
  },  
  methods: {
    fdateformat(val){
        return moment(val.sdate).format("YYYY-MM-DD HH:mm") +'~'+ moment(val.edate).format("MM-DD HH:mm") ; 
    },
    catImg(imgs) {
            return require(`../assets/img/${imgs}`);
    }, 
    getxt(val){
        return val.substring(1, 32)
    },  
    groupBy(array, groups, valueKey) {
      var map = new Map();
      groups = [].concat(groups);
      return array.reduce((r, o) => {
        groups.reduce((m, k, i, { length }) => {
          var child;
          if (m.has(o[k])) return m.get(o[k]);
          if (i + 1 === length) {
            child = Object.assign(...groups.map(k => ({ [k]: o[k] })), {
              [valueKey]: 0
            });
            r.push(child);
          } else {
            child = new Map();
          }
          m.set(o[k], child);
          return child;
        }, map)[valueKey] += +o[valueKey];
        return r;
      }, []);
    },

    getaddress(){
      let city = this.twcity==undefined ? '':this.twcity
      let village = this.twvillage==undefined ? '':this.twvillage
      let town = this.twtown==undefined ? '':this.twtown
      this.address = city +''+ village +''+ town
      this.$emit("toaddress",this.address,city,village,town);
    },
    oncity() {
      this.twvillages = this.groupBy(
        this.myJson.filter(el => {
          return el.city === this.twcity;
        }),
        "village"
      );    
      this.twvillage='' 
      this.twtown=''
      this.twtowns = [];
      this.getaddress()
      //groupBy(data, 'Phase', 'Value')
    },

    onvillage() {
      this.twtowns = this.groupBy(
        this.myJson.filter(el => {
          return el.village === this.twvillage;
        }),
        "town"
      );
      this.twtown=''
      this.getaddress()
    },
    ontwtown(){
      this.getaddress()
    },     
  },   
  created() {
  }, 
  
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.location-selector {
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  padding: 20px;
  background: linear-gradient(135deg, #fafafa 0%, #f8f9fa 100%);
  min-height: 200px;
  font-family: 'Arial', 'Microsoft YaHei', sans-serif;
}

.selector-container {
  background: rgba(255, 255, 255, 0.9);
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  /* 確保在 modal 中有足夠的空間 */
  overflow: visible;
  position: relative;
  z-index: 1;
}

.selector-title {
  text-align: center;
  margin: 0 0 28px 0;
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
  letter-spacing: 0.5px;
}

.selector-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
  align-items: start;
}

.location-field {
  position: relative;
  /* 確保下拉選單在 modal 中正確顯示 */
  z-index: 10;
}

.field-label {
  display: block;
  font-weight: 500;
  margin-bottom: 8px;
  color: #495057;
  font-size: 14px;
  letter-spacing: 0.3px;
}

.required-mark {
  color: #e74c3c;
  font-size: 16px;
  margin-right: 4px;
  font-weight: 600;
}

.field-select {
  width: 100%;
  height: 48px;
  padding: 12px 16px;
  font-size: 15px;
  border: 2px solid #e9ecef;
  border-radius: 12px;
  background: #ffffff;
  color: #495057;
  transition: all 0.3s ease;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 20px;
  /* 修正在 modal 中的顯示問題 */
  position: relative;
  z-index: 1050; /* 高於 Bootstrap modal 的 z-index (1040) */
}

.field-select:focus {
  outline: none;
  border-color: #3498db;
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);
  background-color: #fff;
}

.field-select:hover:not(:disabled) {
  border-color: #74b9ff;
  background-color: #fdfdff;
}

.field-select:disabled {
  background-color: #f8f9fa;
  border-color: #e9ecef;
  color: #6c757d;
  cursor: not-allowed;
  opacity: 0.7;
}

.field-select option {
  padding: 8px 12px;
  background-color: #ffffff;
  color: #495057;
}

/* 響應式設計 */
@media (min-width: 769px) and (max-width: 1024px) {
  .selector-grid {
    gap: 16px;
  }
  
  .field-select {
    height: 46px;
    font-size: 14px;
    padding: 10px 14px;
  }
}

@media (max-width: 768px) {
  .location-selector {
    padding: 16px;
  }
  
  .selector-container {
    padding: 24px 20px;
  }
  
  .selector-title {
    font-size: 20px;
    margin-bottom: 20px;
  }
  
  .selector-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .field-select {
    height: 44px;
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .location-selector {
    padding: 12px;
  }
  
  .selector-container {
    padding: 20px 16px;
  }
  
  .selector-title {
    font-size: 18px;
  }
  
  .selector-grid {
    gap: 16px;
  }
}

/* 美化滾動條 (webkit 瀏覽器) */
.field-select::-webkit-scrollbar {
  width: 6px;
}

.field-select::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 6px;
}

.field-select::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 6px;
}

.field-select::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 載入動畫效果 */
.selector-container {
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 針對 Bootstrap Modal 的特殊樣式 */
.modal .location-selector,
:deep(.modal) .location-selector {
  background: transparent;
  padding: 10px;
  min-height: auto;
}

.modal .selector-container,
:deep(.modal) .selector-container {
  overflow: visible !important;
  position: static;
}

.modal .field-select,
:deep(.modal) .field-select {
  z-index: 1060 !important; /* 更高的 z-index */
}

/* 確保下拉選單選項正確顯示 */
.field-select option {
  padding: 8px 12px;
  background-color: #ffffff;
  color: #495057;
  white-space: nowrap;
  overflow: visible;
}
</style>
